var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-wrap"},[_c('p',[_vm._v("© 2026 张家口分类信息网 版权所有 | 冀ICP备2026013232号-1")])])])
}]

export { render, staticRenderFns }